/**
 * Height of the fixed MainNavigation bar: 50px of content, 10px padding top and
 * bottom, plus the 1px bottom border. Layouts that sit underneath it reserve exactly
 * this much space, so keep the two in step.
 */
export const HEADER_HEIGHT = 71;
